import React from 'react';
import { Route, Redirect, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

export default function PrivateRoute({ component: Component, ...rest }) {
	const rehydrated = useSelector((store) => store._persist.rehydrated);
	const token = useSelector((store) => store?.user?.token?.id_token);

	const { pathname } = useLocation();

	const from = pathname !== '/' ? `?from=${pathname}` : '';

	return (
		<Route
			{...rest}
			render={(props) => {
				if (!rehydrated) {
					return null;
				}
				if (token) {
					return <Component {...props} />;
				}
				return <Redirect to={`/login${from}`} />;
			}}
		/>
	);
}
